import React from "react";

const TaxDocs = () => {
  return <div>TaxDocs</div>;
};

export default TaxDocs;
